import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  items: MovieItem[];
  icon?: string;
}

export default function MovieGrid({ title, subtitle, items, icon }: MovieGridProps) {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div className="flex items-center gap-3">
          {icon && (
            <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ backgroundColor: 'oklch(var(--primary-500)/0.12)' }}>
              <i className={`${icon} text-base`} style={{ color: 'oklch(var(--primary-500))' }}></i>
            </div>
          )}
          <div>
            <h2 className="text-lg md:text-xl font-bold font-heading" style={{ color: 'oklch(var(--foreground-950))' }}>
              {title}
            </h2>
            {subtitle && (
              <p className="text-xs mt-0.5" style={{ color: 'oklch(var(--foreground-400))' }}>{subtitle}</p>
            )}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
        {items.map((item, index) => (
          <Link
            key={item.id}
            to={`/article/${item.id}`}
            className="group cursor-pointer animate-fade-in-up"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-2.5">
              <img
                src={item.poster}
                alt={item.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute top-2 right-2">
                <span className="px-1.5 py-0.5 rounded text-xs font-bold bg-accent-500/90 text-white">
                  {item.rating}
                </span>
              </div>
              {item.isNew && (
                <div className="absolute top-2 left-2">
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-secondary-500/80 text-white">NEW</span>
                </div>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="flex items-center justify-center">
                  <div className="w-9 h-9 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-lg"></i>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="text-sm font-medium truncate group-hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-800))' }}>
              {item.title}
            </h3>
            <p className="text-xs mt-0.5" style={{ color: 'oklch(var(--foreground-400))' }}>
              {item.year} · {item.categoryLabel}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}